import React from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

/**
 * Step 2: company / product information and rich-text details.
 */
const VendorOnboardingStepInformation = ({
  formValues,
  formErrorsVendor,
  formErrors,
  selectedVendor,
  products,
  imageData,
  acceptedFileTypes,
  editorState,
  handleChangevendor,
  handleSelectChange,
  handleFileChange,
  handleChangesVendor,
  onBack,
  onContinue,
}) => (
  <div className="col-md-12">
    <div className="bg-light rounded-3 p-3  mb-3">
      <p className="small text-muted mb-3">
        Fields marked with <span className="text-danger">*</span> are required.
      </p>
      <div className="row">
        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="vendor-company-name">
            Name of Company <span className="text-danger">*</span>
          </label>
          <input
            className="form-control form-control-lg"
            id="vendor-company-name"
            type="text"
            name="companyName"
            value={formValues.companyName}
            onChange={handleChangevendor}
            style={{
              border: formErrorsVendor?.companyName
                ? "1px solid red"
                : "1px solid #00000026",
            }}
          />
          {formErrorsVendor?.companyName && (
            <div className="text-danger small mt-1">{formErrorsVendor.companyName}</div>
          )}
        </div>
        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="vendor-product-category">
            Describe product or service <span className="text-danger">*</span>
          </label>

          <select
            className="form-select"
            id="vendor-product-category"
            name="category"
            value={selectedVendor._id || ""}
            onChange={handleSelectChange}
            style={{
              border: formErrorsVendor?.category
                ? "1px solid red"
                : undefined,
            }}
          >
            <option value="">--Select--</option>
            {products.length > 0 ? (
              products.map((vendor, index) => (
                <option key={index} value={vendor._id}>
                  {vendor.title}
                </option>
              ))
            ) : (
              <option>No vendors available</option>
            )}
          </select>

          {formErrorsVendor?.category && (
            <div className="text-danger small mt-1">{formErrorsVendor.category}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label">Product Name *</label>
          <input
            className="form-control form-control-lg"
            id="inline-form-input"
            type="text"
            name="productname"
            value={formValues.productname}
            onChange={handleChangevendor}
            style={{
              border: formErrorsVendor?.productname
                ? "1px solid red"
                : "1px solid #00000026",
            }}
          />
          {formErrorsVendor.productname && (
            <div className="text-danger small mt-1">{formErrorsVendor.productname}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="vendor-product-blurb">
            Product blurb (max 50 characters)
          </label>
          <input
            className="form-control form-control-lg"
            id="vendor-product-blurb"
            type="text"
            name="productblurb"
            value={formValues.productblurb}
            onChange={handleChangevendor}
          />
          {formErrorsVendor?.productblurb && (
            <div className="text-danger small mt-1">{formErrorsVendor.productblurb}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="vendor-short-description">
            Product description (max 500 characters)
          </label>
          <input
            className="form-control form-control-lg"
            id="vendor-short-description"
            type="text"
            name="description"
            value={formValues.description}
            onChange={handleChangevendor}
          />
          {formErrorsVendor?.description && (
            <div className="text-danger small mt-1">{formErrorsVendor.description}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="pr-fn">
            Website Link URL <span className="text-danger">*</span>
          </label>
          <input
            className="form-control form-control-lg"
            id="inline-form-input"
            type="text"
            name="linkurl"
            value={formValues.linkurl}
            onChange={handleChangevendor}
          />
          {formErrorsVendor?.linkurl && (
            <div className="text-danger small mt-1">{formErrorsVendor.linkurl}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="vendor-owner-name">
            Owner name <span className="text-danger">*</span>
          </label>
          <input
            className="form-control form-control-lg"
            id="vendor-owner-name"
            type="text"
            name="contactName"
            value={formValues.contactName}
            onChange={handleChangevendor}
            style={{
              border: formErrorsVendor?.contactName
                ? "1px solid red"
                : "1px solid #00000026",
            }}
          />
          {formErrorsVendor?.contactName && (
            <div className="text-danger small mt-1">{formErrorsVendor.contactName}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="vendor-email">
            Email <span className="text-danger">*</span>
          </label>
          <input
            className="form-control form-control-lg"
            id="vendor-email"
            type="email"
            name="email"
            autoComplete="email"
            value={formValues.email}
            onChange={handleChangevendor}
            style={{
              border: formErrorsVendor?.email
                ? "1px solid red"
                : "1px solid #00000026",
            }}
          />
          {formErrorsVendor?.email && (
            <div className="text-danger small mt-1">{formErrorsVendor.email}</div>
          )}
        </div>

        <div className="col-sm-6 mb-2">
          <label className="form-label" htmlFor="vendor-phone">
            Phone <span className="text-danger">*</span>
          </label>
          <input
            className="form-control form-control-lg"
            id="vendor-phone"
            type="tel"
            name="phone"
            autoComplete="tel"
            value={formValues.phone}
            onChange={handleChangevendor}
            style={{
              border: formErrorsVendor?.phone
                ? "1px solid red"
                : "1px solid #00000026",
            }}
          />
          {formErrorsVendor?.phone && (
            <div className="text-danger small mt-1">{formErrorsVendor.phone}</div>
          )}
        </div>
        <div className="col-sm-6 mb-2">
          <div className="my-3 file-uploader pt-3">
            <label className="form-label">
              Select a photo to upload: <span className="text-danger">*</span>
            </label>
            <br />
            <input
              id="fileUpload"
              type="file"
              name="image"
              onChange={handleFileChange}
              accept={acceptedFileTypes.map((type) => `.${type}`).join(",")}
            />
            {formErrorsVendor?.image && (
              <div className="text-danger small mt-1">{formErrorsVendor.image}</div>
            )}
          </div>

          <div className="productItemImage">
            {imageData.image.length > 0 && (
              <>
                {imageData.image.map((uploadedImage, index) => (
                  <React.Fragment key={index}>
                    {uploadedImage ? (
                      <div className="product_images">
                        <img
                          className="m-0 mb-3 shadow-sm"
                          src={uploadedImage.images}
                          alt=""
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ))}
              </>
            )}
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <label className="form-label">Product Full Details</label>
          <Editor
            editorState={editorState}
            onEditorStateChange={handleChangesVendor}
            value={formValues.product_fullDetails}
            toolbar={{
              options: [
                "inline",
                "blockType",
                "fontSize",
                "list",
                "textAlign",
                "history",
                "link",
              ],
              inline: {
                options: ["bold", "italic", "underline", "strikethrough"],
              },
              list: { options: ["unordered", "ordered"] },
              textAlign: {
                options: ["left", "center", "right"],
              },
              history: { options: ["undo", "redo"] },
              link: {
                options: ["link", "unlink"],
              },
            }}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
          />
        </div>
      </div>
    </div>
    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center gap-3 mt-4 pt-3 border-top w-100">
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        onClick={onBack}
      >
        Back
      </button>
      <button
        type="button"
        className="btn btn-primary btn-sm align-self-sm-end"
        onClick={onContinue}
      >
        Save &amp; continue
        <i className="fi-chevron-right fs-sm ms-2"></i>
      </button>
    </div>
  </div>
);

export default VendorOnboardingStepInformation;
